import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import MonthSelector from "../MonthSelector";
import CategoryChart from "../CategoryChart";
import BarChart from "../BarChart";
import TransactionTable from "../TransactionTable";
import { LoginUserContext } from "../provider/LoginUserProvider";
import { WorkoutContext } from "../provider/WorkoutProvider";
import { formatMonth } from "../../utils/formatting";
import { format } from "date-fns";

const Report = ({ currentMonth, setCurrentMonth }) => {
  const { isLogined, loading } = useContext(LoginUserContext);
  const { onGetWorkouts, transactions } = useContext(WorkoutContext);
  const today = format(new Date(), "yyyy-MM-dd");
  const [currentDay, setCurrentDay] = useState(today);
  const commonPaperStyle = {
    height: "400px",
    display: "flex",
    flexDirection: "column",
    p: 2,
  };
  useEffect(() => {
    if (loading || !isLogined) return;
    onGetWorkouts();
    // try {
    //   axios.get(`http://127.0.0.1:8000/api/workouts/`).then((res) => {
    //     setTransactions(res.data);
    //   });
    // } catch (error) {
    //   console.error(error);
    // }
  }, [loading, isLogined]);

  const monthlyTransactions = transactions.filter((transaction) => {
    // return transaction.date.startsWith(format(currentMonth, "yyyy-MM"));
    return transaction.date.startsWith(formatMonth(currentMonth));
  });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <MonthSelector
          currentMonth={currentMonth}
          setCurrentMonth={setCurrentMonth}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Paper sx={commonPaperStyle}>
          <CategoryChart monthlyTransactions={monthlyTransactions} />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 8 }}>
        <Paper sx={commonPaperStyle}>
          <BarChart monthlyTransactions={monthlyTransactions} />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TransactionTable monthlyTransactions={monthlyTransactions} />
      </Grid>
    </Grid>
  );
};

export default Report;
